import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=2cbd3f65"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"
import style0 from "./translate.vue?vue&type=style&index=0&id=2cbd3f65&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports